export default function isValidBirthdate(birthdate: Date | unknown): boolean {
  const today = new Date()
  today.setHours(0, 0, 0)

  if (!(birthdate instanceof Date) || today.getFullYear() - birthdate.getFullYear() > 120) {
    return false
  }

  const yearDiff = today.getFullYear() - birthdate.getFullYear()

  if (yearDiff > 18) return true
  if (yearDiff < 18) return false

  // yearDiff === 18 : vérifier mois et jour
  if (birthdate.getMonth() < today.getMonth()) return true
  if (birthdate.getMonth() > today.getMonth()) return false

  return birthdate.getDate() <= today.getDate()
}
